import { reactive } from 'vue';

export const websiteTexts = reactive({
  loaded: false,
  data: {}
});